import { createOtherIncidentHttpRepository } from '@src/main/modules/other_incidents/infrastructure/OtherIncidentHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

type UpdateIncidentStatusParams = {
  id: string;
  status: string;
};

export const updateIncidentStatusUseCase = async (
  { id, status }: UpdateIncidentStatusParams,
  tokenProvider: TokenProvider,
): Promise<void> => {
  const repository = createOtherIncidentHttpRepository(tokenProvider);

  await repository.updateIncident({
    id,
    newState: status,
  });
};
